<template>
    <div class="tumbler" :class="{'active': value}" @click="toggleTumbler">
        <input type="checkbox" :name="name" v-model="value">
        <label :for="name">
            <div class="icon">
                <span class="i-wrapper">
                    <span :class="icon"></span>
                </span>
            </div>
        </label>
    </div>
</template>


<script>
    import { mapState } from 'vuex'

    export default {
        name: "Tumbler",
        components: {

        },
        props: {
            name: {
               default() {
                   return '';
               }
            },
            value: {
               default() {
                   return false;
               }
            },
            icon: {
                default(){
                    return '';
                }
            },
            isDisabled: {
                default(){
                    return false;
                }
            }


        },
        data() {
            return {

            }
        },
        mounted() {
        },
        beforeDestroy(){
        },
        watch: {

        },
        methods: {
            toggleTumbler(){
                if(this.name === 'editable'){
                    this.$store.commit('rules/toggleDrag');
                }
                this.$store.commit('rules/toggleTumbler', this.name);
                this.$emit('change')
            },

        }
    }
</script>

<style scoped>

</style>
